"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var e=require("../_virtual/_tslib.js"),a=require("react/jsx-runtime"),t=require("styled-components"),i=require("@vds/carousels"),n=require("@plans/tiles"),o=require("@plans/wayfinders"),s=require("@plans/blocks"),l=require("@vds/typography"),d=require("@vds/buttons"),r=require("@vds-tokens/core"),p=require("@plans/utilities"),c=require("@vds/utilities"),u=require("@vds/tiles"),m=require("@plans/lists"),g=require("@react-spring/web"),b=require("@vds/type-lockups"),h=require("react");function x(e){return e&&e.__esModule?e:{default:e}}var y=x(t);const f=y.default.div.withConfig({displayName:"ComponentWrapper",componentId:"VDS__sc-wro6yb-0"})`
  display: flex;
  flex-direction: column;
  width: 100%;
`,v=y.default(g.animated.div).withConfig({displayName:"HeaderWrapper",componentId:"VDS__sc-wro6yb-1"})`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 0 auto;
  max-width: ${p.breakpoints.desktop.max};
  width: 100%;
`,w=y.default.div.withConfig({displayName:"ContentWrapper",componentId:"VDS__sc-wro6yb-2"})`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  margin: auto;
  padding-bottom: ${r.LayoutTokens.space["12X"].value};
  padding-left: ${r.LayoutTokens.space["4X"].value};
  padding-right: ${r.LayoutTokens.space["4X"].value};
  width: 100%;
  @media (min-width: ${p.breakpoints.tabletSmall.min}) {
    max-width: ${p.breakpoints.desktop.max};
    padding-left: ${r.LayoutTokens.space["5X"].value};
    padding-right: ${r.LayoutTokens.space["5X"].value};
  }
`,j=y.default.div.withConfig({displayName:"MobileTileCarousel",componentId:"VDS__sc-wro6yb-3"})`
  width: 100%;
  > div > div > div {
    padding-left: 16px;
  }
`,k=y.default.div.withConfig({displayName:"DesktopTileGroup",componentId:"VDS__sc-wro6yb-4"})`
  box-sizing: border-box;
  padding-left: ${r.LayoutTokens.space["4X"].value};
  padding-right: ${r.LayoutTokens.space["4X"].value};
  width: 100%;
  @media (min-width: ${p.breakpoints.tabletSmall.min}) {
    max-width: ${p.breakpoints.desktop.max};
    padding-left: ${r.LayoutTokens.space["5X"].value};
    padding-right: ${r.LayoutTokens.space["5X"].value};
  }
  @media (max-width: ${p.breakpoints.mobileLarge.max}) {
    display: none;
    visibility: hidden;
  }
  @media (min-width: 1440px) {
    margin: auto;
  }
  > div {
    height: auto !important;
  }
`,T=y.default.div.withConfig({displayName:"DataTileMobileWrapper",componentId:"VDS__sc-wro6yb-5"})`
  display: flex;
  flex-direction: column;
  // Account for when on tablet and there are less than 3 tiles
  ${({noFullHeight:e})=>!e&&"height: 100%;"};
  width: 100%;
`,$=y.default(g.animated.div).withConfig({displayName:"DataTileDesktopWrapper",componentId:"VDS__sc-wro6yb-6"})`
  display: flex;
  /* ${({mobile:e})=>e&&"  height: 100%"} */
  flex-direction: column;
  width: 100%;
`,L=y.default.div.withConfig({displayName:"HeadingWrapper",componentId:"VDS__sc-wro6yb-7"})`
  display: flex;
  flex-direction: column;
  padding-bottom: ${r.LayoutTokens.space["8X"].value};
  padding-top: ${r.LayoutTokens.space["8X"].value};
  width: 100%;
  @media (min-width: ${p.breakpoints.tabletSmall.min}) {
    flex-direction: row;
    justify-content: space-between;
    padding-top: ${r.LayoutTokens.space["16X"].value};
    padding-bottom: ${r.LayoutTokens.space["12X"].value};
    ${({hasPromos:e})=>e&&`gap: ${r.LayoutTokens.space["8X"].value};`};
  }
`,_=y.default.div.withConfig({displayName:"PromoCarouselWrapper",componentId:"VDS__sc-wro6yb-8"})`
  padding-top: ${r.LayoutTokens.space["8X"].value};
  width: 100%;
  @media (min-width: ${p.breakpoints.tabletSmall.min}) {
    padding-top: unset;
    width: calc(50% - ${r.LayoutTokens.space["6X"].value});
  }
`,X=y.default.div.withConfig({displayName:"PromoTitleWrapper",componentId:"VDS__sc-wro6yb-9"})`
  padding-bottom: ${r.LayoutTokens.space["4X"].value};
  padding-left: ${r.LayoutTokens.space["4X"].value};
  @media (min-width: ${p.breakpoints.tabletSmall.min}) {
    padding-left: ${r.LayoutTokens.space["5X"].value};
  }
`,C=y.default.span.withConfig({displayName:"TitleWrapper",componentId:"VDS__sc-wro6yb-10"})`
  align-self: flex-start;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: ${r.LayoutTokens.space["3X"].value};
  padding-left: ${r.LayoutTokens.space["4X"].value};
  padding-right: ${r.LayoutTokens.space["4X"].value};
  width: 100%;
  @media (min-width: ${p.breakpoints.tabletSmall.min}) {
    align-items: flex-start;
    align-self: flex-start;
    ${({hasPromos:e})=>e&&"width: 50%;"};
    padding-left: ${r.LayoutTokens.space["5X"].value};
    padding-right: ${r.LayoutTokens.space["5X"].value};
    gap: ${r.LayoutTokens.space["4X"].value};
  }
`,O=y.default.span.withConfig({displayName:"TitleAlignmentWrapper",componentId:"VDS__sc-wro6yb-11"})`
  text-align: left;
  width: 100%;
  @media (min-width: ${p.breakpoints.tabletSmall.min}) {
    text-align: ${({alignment:e})=>e||"center"};
  }
`,S=y.default.div.withConfig({displayName:"FootnoteWrapper",componentId:"VDS__sc-wro6yb-12"})`
  display: flex;
  flex-direction: column;
  gap: ${r.LayoutTokens.space["3X"].value};
  padding-top: ${r.LayoutTokens.space["8X"].value};
`,I=y.default(g.animated.div).withConfig({displayName:"AllPlansBlockWrapper",componentId:"VDS__sc-wro6yb-13"})`
  max-width: ${p.breakpoints.desktop.max};
`,D=y.default(g.animated.div).withConfig({displayName:"AllPlansTileWrapper",componentId:"VDS__sc-wro6yb-14"})`
  display: flex;
  flex-direction: ${({mobile:e})=>e?"column":"row"};
  gap: ${({mobile:e})=>e?r.LayoutTokens.space["4X"].value:r.LayoutTokens.space["6X"].value};

  max-width: ${p.breakpoints.desktop.max};
`,N=y.default.div.withConfig({displayName:"AllPlansTile",componentId:"VDS__sc-wro6yb-15"})`
  @media (max-width: ${p.breakpoints.mobileLarge.max}) {
    width: 100%;
  }
  ${({width:e})=>e&&`width: ${e}`}
`,V=y.default.div.withConfig({displayName:"DataFeatureTileWrapper",componentId:"VDS__sc-wro6yb-16"})`
  width: 100%;
`,W=y.default.div.withConfig({displayName:"HelperTextWrapper",componentId:"VDS__sc-wro6yb-17"})`
  align-items: ${({alignment:e})=>"left"===e?"flex-start":"center"};
  display: flex;
  flex-direction: column;
  gap: ${r.LayoutTokens.space["3X"].value};
  padding: ${r.LayoutTokens.space["6X"].value} 0px;
  text-align: ${({alignment:e})=>"center"===e?"center":"left"};
  > p > div {
    justify-content: ${({alignment:e})=>"center"===e?"center":"flex-start"};
  }
  a {
    font-size: 11px;
  }
`,A=y.default.div.withConfig({displayName:"HelperTextLinks",componentId:"VDS__sc-wro6yb-18"})`
  display: flex;
  flex-direction: column;
  gap: 0;
  @media (min-width: ${p.breakpoints.tabletSmall.min}) {
    flex-direction: row;
    gap: ${r.LayoutTokens.space["2X"].value};
  }
`,P=y.default.div.withConfig({displayName:"BroadbandFactsWrapper",componentId:"VDS__sc-wro6yb-19"})`
  padding-top: ${r.LayoutTokens.space["12X"].value};
`,z=y.default.div.withConfig({displayName:"BroadbandFactsTitleWrapper",componentId:"VDS__sc-wro6yb-20"})``,q=y.default.div.withConfig({displayName:"BroadbandFactsButtonWrapper",componentId:"VDS__sc-wro6yb-21"})`
  display: flex;
  padding-top: ${r.LayoutTokens.space["6X"].value};
`,F=y.default.div.withConfig({displayName:"TextLinkWrapper",componentId:"VDS__sc-wro6yb-22"})`
  align-items: center;
  display: flex;
  justify-content: center;
  padding-top: ${r.LayoutTokens.space["3X"].value};
`,G=y.default.div.withConfig({displayName:"ContentTextLinkWrapper",componentId:"VDS__sc-wro6yb-23"})`
  align-items: center;
  display: flex;
  justify-content: center;
  padding-top: ${r.LayoutTokens.space["6X"].value};
`,B=y.default.div.withConfig({displayName:"BroadbandFactsNoticeWrapper",componentId:"VDS__sc-wro6yb-24"})`
  padding-top: ${r.LayoutTokens.space["6X"].value};
  @media (min-width: ${p.breakpoints.tabletSmall.min}) {
    padding-top: ${r.LayoutTokens.space["8X"].value};
  }
`,H=y.default.div.withConfig({displayName:"BroadbandLabelWrapper",componentId:"VDS__sc-wro6yb-25"})`
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: ${r.LayoutTokens.space["6X"].value};
  justify-content: center;
  padding-top: ${({$hasNotice:e})=>e?r.LayoutTokens.space["4X"].value:r.LayoutTokens.space["6X"].value};
  @media (min-width: ${p.breakpoints.tabletSmall.min}) {
    padding-top: ${({$hasNotice:e})=>e?r.LayoutTokens.space["6X"].value:r.LayoutTokens.space["8X"].value};
    flex-direction: row;
    align-items: start;
    flex-wrap: wrap;
    justify-content: start;
    > div {
      width: calc(50% - 12px);
    }
  }
  @media (min-width: ${p.breakpoints.tabletLarge.max}) {
    flex-wrap: nowrap;
    > div {
      width: 33%;
    }
  }
`,E=y.default(g.animated.div).withConfig({displayName:"PromoOuterWrapper",componentId:"VDS__sc-wro6yb-26"})`
  display: flex;
  width: 100%;
`,R=y.default.div.withConfig({displayName:"PromoWrapper",componentId:"VDS__sc-wro6yb-27"})`
  padding: 0 ${r.LayoutTokens.space["4X"].value} ${r.LayoutTokens.space["8X"].value}
    ${r.LayoutTokens.space["4X"].value};
  width: 100%;
  @media (min-width: ${p.breakpoints.tabletSmall.min}) {
    padding: 0 ${r.LayoutTokens.space["5X"].value}
      ${r.LayoutTokens.space["12X"].value} ${r.LayoutTokens.space["5X"].value};
  }
`,M=y.default(g.animated.div).withConfig({displayName:"ExtendedToggleWrapper",componentId:"VDS__sc-wro6yb-28"})`
  box-sizing: border-box;
  display: flex;
  flex-direction: ${({mobile:e})=>e?"column":"row"};
  justify-content: flex-start;
  padding-bottom: ${r.LayoutTokens.space["6X"].value};
  padding-bottom: ${r.LayoutTokens.space["6X"].value};
  padding-left: ${({mobile:e})=>e?r.LayoutTokens.space["4X"].value:r.LayoutTokens.space["5X"].value};
  ${({mobile:e})=>e&&`gap:${r.LayoutTokens.space["5X"].value};`}
  padding-right: ${({mobile:e})=>e?r.LayoutTokens.space["4X"].value:r.LayoutTokens.space["5X"].value};
  position: relative;
  width: 100%;
  z-index: 2;
  @media (max-width: ${p.breakpoints.mobileLarge.max}) {
    gap: ${r.LayoutTokens.space["6X"].value} !important;
  }
`,U=y.default(g.animated.div).withConfig({displayName:"ExtendedToggleTextLinkWrapper",componentId:"VDS__sc-wro6yb-29"})`
  align-self: ${({mobile:e})=>e?"":"center"};
  min-width: max-content;
`,K=y.default.div.withConfig({displayName:"PromoSpacer",componentId:"VDS__sc-wro6yb-30"})`
  ${({viewport:e})=>e&&`\n    height: ${"mobile"===e?"20px":"24px"};\n  `}
`,Q=y.default.div.withConfig({displayName:"TilePromoWrapper",componentId:"VDS__sc-wro6yb-31"})`
  max-height: ${({viewport:e})=>"mobile"===e?"20px":"24px"};
  ${({horizontalAlignment:e})=>e&&`\n    display: flex;\n    flex-direction: row;\n    justify-content: ${"center"===e?"center":"flex-start"};\n  `}
`,J=y.default.div.withConfig({displayName:"ScreenReaderText",componentId:"VDS__sc-wro6yb-32"})`
  border: 0;
  clip: rect(0, 0, 0, 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  white-space: nowrap;
  width: 1px;
`,Y=y.default.div.withConfig({displayName:"DesktopInnerWrapper",componentId:"VDS__sc-wro6yb-33"})`
  ${({maxWidth:e})=>e&&`max-width:${e}`};
  display: flex;
  gap: ${r.LayoutTokens.space["3X"].value} ${r.LayoutTokens.space["3X"].value};
  width: 100%;
  @media (min-width: ${p.breakpoints.tabletSmall.min}) {
    gap: ${r.LayoutTokens.space["6X"].value};
  }
`;var Z=c.withVDSManager((t=>{const{tiles:c,title:x,subtitle:y,wayfinder:Z,footnote:ee,allPlansLockup:ae,buttonGroup:te,helperText:ie,dataTileGroupMaxWidth:ne,viewport:oe="desktop",broadbandFacts:se,promo:le,autoPay:de,theme:re,promos:pe}=t,ce="mobile"===oe,ue="tablet"===oe,me=(e=>{if(!e)return;let a=0;const t={};return e.forEach(((e,i)=>{let n=0;e.label&&e.label.children&&(n+=1),e&&e.buttonGroup&&e.buttonGroup.data.length&&(n+=e.buttonGroup.data.length),n>a&&(a=n),t[i]={ctaCount:n}})),{TILE_CTA_CHECKER:t,maxCTA:a}})(c),ge=(null==me?void 0:me.maxCTA)||0,be=(null==me?void 0:me.TILE_CTA_CHECKER)||{},he=!!(null==c?void 0:c.filter((e=>!!e.promo)).length),xe=g.useSpring(Object.assign({},p.fadeAndSlide({direction:"vertical",distance:"50px"}))),ye=[g.useSpring(Object.assign(Object.assign({},p.fadeAndSlide({direction:"vertical",distance:"100px"})),{delay:100})),g.useSpring(Object.assign(Object.assign({},p.fadeAndSlide({direction:"vertical",distance:"100px"})),{delay:150}))],fe=g.useSpring(Object.assign(Object.assign({},p.fadeAndSlide({direction:"vertical",distance:"50px"})),{delay:200})),ve=(t,i,o)=>{var s,l,{promo:d}=t,r=e.__rest(t,["promo"]);const u=p.generateId(),g=c&&c.some((e=>e.price&&e.price.price&&-1!==e.price.price.indexOf(".")));return a.jsxs(h.Fragment,{children:[(ce||ue)&&a.jsxs(T,Object.assign({id:u,noFullHeight:ue&&(o||0)<3},{children:[d&&a.jsx(Q,Object.assign({viewport:"mobile",horizontalAlignment:d.horizontalAlignment},{children:a.jsx(m.IconListItem,Object.assign({},d,{containerId:u,spacing:"4px",size:"small"}))})),!d&&he&&a.jsx(K,{viewport:"mobile"}),a.jsx(n.Data,Object.assign({variant:"full",elementSurface:"dark",padding:ce?"16px":"24px"},r,{borderRadius:"24px",width:"100%",height:"100%",backgroundColor:"monarch"===re?"stone":r.backgroundColor,preserveFooterHeight:(null===(s=be[i])||void 0===s?void 0:s.ctaCount)<ge},r.price&&{price:g?Object.assign({size:ce?"medium":"large"},r.price):Object.assign({},r.price)},{viewport:"focused"===r.variant?oe:void 0}))]})),!ce&&!ue&&a.jsxs($,Object.assign({style:ye[i]||ye[1],id:u},{children:[d&&a.jsx(Q,Object.assign({viewport:"desktop",horizontalAlignment:d.horizontalAlignment},{children:a.jsx(m.IconListItem,Object.assign({},d,{containerId:u,spacing:"8px",size:"small"}))})),!d&&he&&a.jsx(K,{viewport:"desktop"}),a.jsx(n.Data,Object.assign({variant:"full",elementSurface:"dark",padding:"24px"},r,{borderRadius:"24px",width:"100%",height:"100%",backgroundColor:"monarch"===re?"stone":r.backgroundColor,preserveFooterHeight:(null===(l=be[i])||void 0===l?void 0:l.ctaCount)<ge},r.price&&{price:g?Object.assign({size:"large"},r.price):Object.assign({},r.price)}))]}),i)]},i)},we=()=>{const e=null==c?void 0:c.length;return e?a.jsx(k,Object.assign({role:"radiogroup"},{children:a.jsx(Y,Object.assign({maxWidth:ne},{children:null==c?void 0:c.map(((a,t)=>ve(a,t,e)))}))})):null},je=e=>a.jsx(j,Object.assign({role:"radiogroup"},{children:a.jsx(i.Carousel,{viewport:"mobile",aspectRatio:"none",renderItem:(a,t)=>ve(a,t,e),data:c,peek:"minimum",layout:ce?"1UP":"2UP",gutter:"12px"})})),ke={layout:"1UP",peek:"standard",paginationDisplay:"none"},Te=pe&&pe.items&&pe.items.length;return a.jsxs(f,{children:[Z&&a.jsx(o.Wayfinder,Object.assign({background:"transparent",variant:"product"},Z)),a.jsxs(v,Object.assign({style:xe},{children:[a.jsxs(L,Object.assign({hasPromos:Te},{children:[(x||y)&&a.jsxs(C,Object.assign({hasPromos:Te},{children:[x&&x.children&&a.jsx(O,Object.assign({alignment:Te?"left":x.alignment},{children:a.jsx(l.Title,Object.assign({},x,{size:"XLarge"},{children:null==x?void 0:x.children}))})),y&&y.children&&a.jsx(O,Object.assign({alignment:Te?"left":y.alignment},{children:a.jsx(l.Title,Object.assign({size:"medium",color:r.ColorTokens.elements.secondary.onlight.value},y))}))]})),Te&&a.jsxs(_,{children:[pe.title&&a.jsx(X,{children:a.jsx(l.Body,Object.assign({size:"large",bold:!0},pe.title))}),a.jsx(i.Carousel,{layout:"2UP",gutter:"24px",peek:"none",surface:"light",paginationDisplay:"persistent",viewportOverride:{mobile:ke,mobileLarge:ke},aspectRatio:"none",data:pe.items,renderItem:e=>a.jsx(u.TileContainer,Object.assign({padding:"16px"},e))})]})]})),le&&a.jsx(E,Object.assign({style:xe},{children:a.jsx(R,{children:a.jsx(u.TileContainer,Object.assign({padding:"16px",height:"100%",width:"100%"},le))})})),de&&a.jsxs(M,Object.assign({style:xe,mobile:ce},{children:[de.toggle&&a.jsx(s.ExtendedToggle,Object.assign({},de.toggle)),de.textLink&&a.jsx(U,Object.assign({mobile:ce},{children:a.jsx(d.TextLink,Object.assign({type:"standAlone"},de.textLink))}))]})),(()=>{const e=null==c?void 0:c.length;switch(oe){case"tablet":return 3===e?je(e):we();case"mobile":return je();default:return we()}})()]})),a.jsxs(w,{children:[te&&a.jsx(G,{children:a.jsx(d.ButtonGroup,Object.assign({},te,{rowQuantity:{desktop:1,mobile:1,tablet:1},childWidth:ce?"100%":"auto"}))}),ie&&a.jsxs(W,Object.assign({alignment:ce?"left":ie.alignment},{children:[a.jsx(l.Micro,Object.assign({},ie)),a.jsx(A,{children:ie.textLinkGroup&&ie.textLinkGroup.map((e=>a.jsx("div",{children:a.jsx(d.TextLink,Object.assign({size:"small",type:"standAlone"},e))})))})]})),ae&&"tile"===ae.variant&&a.jsxs(D,Object.assign({mobile:ce,style:fe},{children:[a.jsx(N,Object.assign({width:(null==ae?void 0:ae.promo)?"100%":"50%"},{children:a.jsx(n.Tile,Object.assign({borderRadius:ce?"12px":"24px",theme:"monarch",height:"100%",width:"100%",padding:ce?r.LayoutTokens.space["4X"].value:r.LayoutTokens.space["6X"].value,background:r.ColorTokens.palette.stone.value},{children:a.jsx(s.AllPlans,Object.assign({},ae,ae.list&&{list:Object.assign({layout:ce?"vertical":"horizontal"},ae.list)},ae.title&&{title:Object.assign({size:"small"},ae.title)}))}))})),ae.promo&&a.jsx(V,{children:a.jsx(n.DataFeature,Object.assign({height:"100%",variant:"image",borderRadius:ce?"12px":"24px",padding:ce?r.LayoutTokens.space["4X"].value:r.LayoutTokens.space["6X"].value,background:ae.promo.backgroundImage?`center / cover no-repeat url(${ae.promo.backgroundImage}), ${r.ColorTokens.palette.stone.value}`:r.ColorTokens.palette.stone.value},ae.promo,{backgroundImage:void 0}))})]})),ae&&"tile"!==ae.variant&&a.jsx(I,Object.assign({mobile:ce,style:fe},{children:a.jsx(s.AllPlans,Object.assign({},ae))})),a.jsxs(S,Object.assign({style:ye[0]},{children:[a.jsx(J,{children:"footnotes"}),ee&&ee.map((e=>a.jsx(s.HelperText,Object.assign({color:"secondary"},e))))]})),se&&a.jsxs(P,{children:[a.jsx(z,{children:a.jsx(b.TitleLockup,Object.assign({},se.header))}),ce&&se.buttonGroup&&a.jsx(q,{children:a.jsx(d.ButtonGroup,Object.assign({childWidth:"100%",alignment:"left",rowQuantity:{mobile:1}},se.buttonGroup))}),se.notice&&a.jsx(B,{children:a.jsx(u.TileContainer,Object.assign({padding:`${r.LayoutTokens.space["3X"].value} ${r.LayoutTokens.space["4X"].value}}`,backgroundColor:"secondary",onClick:void 0,height:"auto"},se.notice))}),a.jsx(H,Object.assign({$hasNotice:!!se.notice},{children:se.broadbandLabel&&se.broadbandLabel.map((e=>a.jsxs("div",{children:[a.jsx(n.BroadbandLabel,Object.assign({},e)),ce&&a.jsx(F,{children:a.jsx(d.TextLink,Object.assign({type:"standAlone",disabled:!1},se.textLink))})]})))})),!ce&&se.textLink&&a.jsx(F,{children:a.jsx(d.TextLink,Object.assign({type:"standAlone",disabled:!1},se.textLink))})]})]})]})}));exports.default=Z;
